import { useTranslation } from "react-i18next";
import ApiErrorsList from "@profilog/misc/errors/ApiErrorsList";

export default function NotLoadedSection({ apiGetErrors }) {
    const { t } = useTranslation();
    return apiGetErrors != null ? <ApiErrorsList apiGetErrors={apiGetErrors} /> : t("records.Edit.LoadingData");
}
